var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { CircularProgress, Container, Box, Button, Typography, Stack } from '@mui/material';
import { AccountBalance, Print, CheckCircle } from '@mui/icons-material';
import { useParams } from 'react-router-dom';
import { RequerimentosApi } from '../../../apis/requerimento-api';
import { Requerimento } from '../../../model/Requerimento';
import { RequerimentoApi } from '../../../apis/requerimentoAPi';
import { SituacaoRequerimentoEnum } from '../../../model/enums/SituacaoRequerimentoEnum';
import { ShowContent } from '../../../components/ShowContent';
import Card from '@mui/material/Card';
import { SimpleTable } from '../../../components/SimpleTable/SimpleTable';
export var TaxasEmitidas = function () {
    //region Constants
    var TIMER_INTERVAL = 5000;
    var RETRY_NUMBER = 5;
    var intervalRef = useRef(null);
    var _a = useState([]), taxas = _a[0], setTaxas = _a[1];
    var _b = useState(new Requerimento()), requerimento = _b[0], setRequerimento = _b[1];
    var _c = useState(false), semTaxas = _c[0], setSemTaxas = _c[1];
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    var _e = useState(''), error = _e[0], setError = _e[1];
    var _f = useState(null), taxaSelecionada = _f[0], setTaxaSelecionada = _f[1];
    var _g = useState(0), contadorReq = _g[0], setContadorReq = _g[1];
    var id = useParams().id;
    //endregion
    //region Hooks
    useEffect(function () {
        if (id && (taxas === null || taxas === void 0 ? void 0 : taxas.length) === 0 && !semTaxas) {
            handleLoadData(Number(id));
            intervalRef.current = setInterval(function () {
                handleLoadData(Number(id));
            }, TIMER_INTERVAL);
        }
        return function () {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [id, taxas === null || taxas === void 0 ? void 0 : taxas.length, semTaxas]);
    useEffect(function () {
        if (id) {
            var _id = Number(id);
            if (!isNaN(_id)) {
                RequerimentoApi.buscarPorId(_id).then(function (response) {
                    setRequerimento(response);
                    var isento = (response === null || response === void 0 ? void 0 : response.situacao) === SituacaoRequerimentoEnum.ISENTO_TAXAS;
                    if (isento) {
                        setSemTaxas(true);
                        setLoading(false);
                    }
                }).catch(function (error) { return setError(error); });
            }
        }
    }, [id]);
    var columns = [
        { label: 'Descrição', value: 'nome', renderHtml: true },
        { label: 'Tipo', value: 'codigoSefaz' },
        { label: 'Nº DAR', value: 'numDar', renderHtml: true },
        { label: 'Valor (R$)', value: 'valor' },
        { label: 'Gerada em', value: 'dataCriacao' },
        { label: 'Status', value: 'status', renderHtml: true },
    ];
    var tableValues = useMemo(function () {
        return taxas.map(function (t) {
            var _a, _b;
            var isQuitado = ((_a = t.status) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'quitado' || t.status === 'QUITADO';
            var isPendente = ((_b = t.status) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === 'pendente' || t.status === 'PENDENTE';
            return __assign(__assign({}, t), { viewIcon: isQuitado ? _jsx(CheckCircle, { sx: { color: 'success.main' } }) : _jsx(Print, { sx: { color: 'primary.main' } }), nome: "<div>".concat(t.nome, "</div><small style=\"color: #666;\">").concat(t.processoRequerimento || '', "</small>"), numDar: "<span style=\"color: #1976d2; font-weight: 500;\">".concat(t.numDar || '—', "</span>"), valor: t.valor ? t.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '—', dataCriacao: t.dataCriacao ? t.dataCriacao.split('T')[0] : '—', status: "<span style=\"border: 1px solid ".concat(isQuitado ? '#2e7d32' : '#1976d2', "; color: ").concat(isQuitado ? '#2e7d32' : '#1976d2', "; padding: 4px 16px; border-radius: 20px; font-weight: 500; font-size: 0.75rem; display: inline-block;\">").concat(t.status || 'PENDENTE', "</span>") });
        });
    }, [taxas]);
    var formatCurrency = function (value) {
        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };
    var totalGeral = useMemo(function () {
        return taxas.reduce(function (acc, t) { var _a; return acc + ((_a = t.valor) !== null && _a !== void 0 ? _a : 0); }, 0);
    }, [taxas]);
    var totalQuitado = useMemo(function () {
        return taxas
            .filter(function (t) { var _a, _b; return ['quitado', 'isento'].includes((_b = (_a = t.status) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : ''); })
            .reduce(function (acc, t) { var _a; return acc + ((_a = t.valor) !== null && _a !== void 0 ? _a : 0); }, 0);
    }, [taxas]);
    var totalPendente = useMemo(function () {
        return taxas
            .filter(function (t) { var _a, _b; return !['quitado', 'isento'].includes((_b = (_a = t.status) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : ''); })
            .reduce(function (acc, t) { var _a; return acc + ((_a = t.valor) !== null && _a !== void 0 ? _a : 0); }, 0);
    }, [taxas]);
    //endregion
    //region Handles
    var handleLoadData = function (requerimentoId) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            RequerimentosApi.buscarTaxas(requerimentoId).then(function (response) {
                if (response && response.length > 0) {
                    setTaxas(response);
                    setLoading(false);
                    if (intervalRef.current) {
                        clearInterval(intervalRef.current);
                        intervalRef.current = null;
                    }
                }
                else {
                    verify();
                }
            }).catch(function (err) {
                console.error(err);
                verify();
            });
            return [2 /*return*/];
        });
    }); };
    var verify = function () {
        setContadorReq(function (prev) {
            var novoContador = prev + 1;
            if (novoContador >= RETRY_NUMBER) {
                setSemTaxas(true);
                setLoading(false);
                if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                    intervalRef.current = null;
                }
            }
            return novoContador;
        });
    };
    var handleVerTaxa = function (index) {
        var taxa = taxas[index];
        if (id && taxa.numDar) {
            setLoading(true);
            RequerimentosApi.buscarPdfTaxa(id, taxa.numDar).then(function (blob) {
                var _blob = blob.data || blob; // Handle both axios response and direct data
                if (_blob && (_blob.size > 0 || _blob.byteLength > 0)) {
                    var url = URL.createObjectURL(new Blob([_blob], { type: 'application/pdf' }));
                    var link = document.createElement('a');
                    link.href = url;
                    link.target = '_blank';
                    link.rel = 'noopener noreferrer';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
                setLoading(false);
            }).catch(function (err) {
                console.error(err);
                setLoading(false);
            });
        }
    };
    //endregion
    return (_jsxs(Container, __assign({ maxWidth: "lg", sx: { py: 4 } }, { children: [_jsx(Typography, __assign({ variant: "h5", align: "center", sx: { fontWeight: 'bold', mb: 4 } }, { children: "Status Financeiro" })), _jsxs(Box, __assign({ mb: 4, textAlign: "left" }, { children: [_jsxs(Stack, __assign({ direction: "row", spacing: 2, alignItems: "center", mb: 1 }, { children: [_jsx(AccountBalance, { color: "primary", sx: { fontSize: 24 } }), _jsx(Typography, __assign({ variant: "h5", sx: { fontWeight: 800 } }, { children: "Taxas do Processo" }))] })), _jsx(Typography, __assign({ variant: "caption", color: "textSecondary", sx: { ml: 5, display: 'block' } }, { children: "Taxas geradas automaticamente no protocolo. Adicione novas conforme necessidade." }))] })), _jsx(ShowContent, __assign({ show: loading }, { children: _jsxs(Card, __assign({ sx: { p: 4, textAlign: 'center' } }, { children: [_jsx(Typography, __assign({ variant: "subtitle1", gutterBottom: true }, { children: "Buscando taxas, por favor aguarde..." })), _jsx(Box, __assign({ mt: 2, display: "flex", justifyContent: "center" }, { children: _jsx(CircularProgress, {}) }))] })) })), _jsx(ShowContent, __assign({ show: !loading && semTaxas }, { children: _jsxs(Card, __assign({ sx: { p: 4, textAlign: 'center' } }, { children: [_jsx(Typography, __assign({ variant: "h6", color: "textSecondary" }, { children: "Nenhuma taxa pendente encontrada para este requerimento." })), _jsx(Button, __assign({ variant: "outlined", sx: { mt: 2 }, onClick: function () { return window.history.back(); } }, { children: "Voltar" }))] })) })), _jsxs(ShowContent, __assign({ show: !loading && !semTaxas }, { children: [_jsxs(Card, __assign({ sx: { p: 0, boxShadow: 'none', border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden' } }, { children: [_jsx(SimpleTable, { columns: columns, values: tableValues, showOptions: true, onHandleView: handleVerTaxa, emptyText: "Nenhuma taxa encontrada.", viewIcon: _jsx(Print, { sx: { color: 'primary.main' } }) }), _jsx(Box, __assign({ p: 2, display: "flex", justifyContent: "flex-end", alignItems: "center", sx: { borderTop: '1px solid #e0e0e0' } }, { children: _jsxs(Stack, __assign({ direction: "row", spacing: 4 }, { children: [_jsxs(Typography, __assign({ variant: "body2", sx: { fontWeight: 'bold' } }, { children: ["Total: ", formatCurrency(totalGeral)] })), _jsxs(Typography, __assign({ variant: "body2", sx: { fontWeight: 'bold', color: '#2e7d32' } }, { children: ["Quitado/Isento: ", formatCurrency(totalQuitado)] })), _jsxs(Typography, __assign({ variant: "body2", sx: { fontWeight: 'bold', color: totalPendente > 0 ? '#d32f2f' : '#1976d2' } }, { children: ["Pendente: ", formatCurrency(totalPendente)] }))] })) }))] })), _jsx(Box, __assign({ mt: 4 }, { children: _jsx(Button, __assign({ variant: "outlined", color: "primary", onClick: function () { return window.history.back(); }, sx: {
                                borderRadius: '4px',
                                textTransform: 'uppercase',
                                fontWeight: 'bold',
                                px: 4
                            } }, { children: "VOLTAR PARA LISTAGEM" })) }))] }))] })));
};
